export const CREATE_MIX = 'MIX/CREATE';
export const LOAD_MIX = 'MIX/LOAD';
export const LOADING_STATUS = 'MIX/LOADING_STATUS';
